import { css } from '@emotion/react'

const styles = () => {
    return {
        text: css` padding-left: 30px `,
        context: css`
            display: flex;
            width: 100%;
        `,
        deleteButton: css`
            padding: 0;
            padding-left: 10px;
            align-self: start;
        `,
        emptyCommentAria: css`
            width: 100%;
            height: 310px;
        `,
    }
}

export default styles
